import { z } from 'zod'
import { bzOptional } from '../common-schemas'

export const EquipmentManufacturerSchema = bzOptional(z.string())
export type EquipmentManufacturer = z.infer<typeof EquipmentManufacturerSchema>

export const KNOWN_MANUFACTURERS: string[] = [
  'ACiQ',
  'AirEase',
  'AirQuest',
  'Amana',
  'American Standard',
  'Bosch',
  'Bryant',
  'Carrier',
  'Champion',
  'Coleman',
  'Daikin',
  'Ducane',
  'Goettl',
  'Goodman',
  'Frigidaire',
  'Lennox',
  'Mitsubishi',
  'Rheem',
  'Trane',
  'WaterFurnace',
  'York',
]

export const EquipmentModelNumberSchema = z.string()
export type EquipmentModelNumber = z.infer<typeof EquipmentModelNumberSchema>

export const EquipmentSerialNumberSchema = z.string()
export type EquipmentSerialNumber = z.infer<typeof EquipmentSerialNumberSchema>
